import styled from 'styled-components'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { colors, IColoredTheme } from '../../styles'

export const StyledNavLink = styled(NavLink)<NavLinkProps & IColoredTheme>`
  all: unset;
  display: block;
  max-width: 100%;
  font-family: knowledge2017regular;
  padding: 8px 12px 8px 24px;
  color: ${colors.text};

  &.active,
  &:hover {
    cursor: pointer;
    background-color: ${colors.lightAccent};
  }
` as React.ComponentType<NavLinkProps & IColoredTheme>
